import uuid from "uuid";
/**
 * Will generate a custom key using the current result from an uuid
 */
const createKey = (pre = "k") => {
  return `${pre}${uuid.v4()}`;
};

export default createKey;
